

import '../Styles/About.css';
import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import CountUp from 'react-countup';

export default function SalaAbout() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      offset: 100,
    });
  }, []);

  return (
    <div className="Sala-About-Container" id='about'>
      <div className='Sala-About-Container-placer'>

        {/* Text Section */}
        <div className="Sala-About-TextContainer" data-aos="fade-right">
            <h5 className="Sala-About-Subtitle">The Sala</h5>
            <p className="Sala-About-Subtitle-p">
              Welcome to a lifestyle where heritage meets harvest. At Sala, you own more than just land — you become part of The Sala Resort, that blends timeless culture with thoughtful returns.
            </p>
            
            <div className='Sala-About-Earn-Container' data-aos="fade-up" data-aos-delay="100">  
              <h2 className="Sala-About-Subtitle1">Earn From</h2>
              <div className='Sala-About-Earn-Container-li-wrapper'>

              <li className="Sala-About-Subtitle-p">Rental Returns through resort-managed heritage villas</li>
              <li className="Sala-About-Subtitle-p">Agricultural Yield from managed coffee, pepper, and timber plantations</li>
              <li className="Sala-About-Subtitle-p">High Land Value Appreciation in a growing heritage destination</li>
              </div>
            </div>

            <div className="Sala-About-Highlight-Container" data-aos="fade-up" data-aos-delay="300">
              <h2 className="Sala-About-Subtitle2">Highlights</h2>
              <div className="Sala-About-Highlight-ListWrapper">
                <ul className="Sala-About-Highlight-List">
                  <li>55 acres of managed coffee plantation</li>
                  <li>Hoysala-style heritage resort within the estate</li>
                  <li>Private 10-guntha plots with road connectivity</li>
                </ul>
                <ul className="Sala-About-Highlight-List">
                  <li>Well-maintained pepper & coffee plantations</li>
                  <li>Private pool rooms</li>
                  <li>Dedicated health care facilities</li>
                  <li>Free membership to The Sala Resort</li>
                </ul>
              </div>
            </div>        
        </div>

        {/* Images Section */}
        <div className="Sala-About-Images" data-aos="zoom-in" data-aos-delay="200" >
            <div className="Sala-About-Image layer1"/>
            <div className="Sala-About-Image layer2"/>
            <div className="Sala-About-Image layer3" />
        </div>
      </div>

      {/* Counters Section */}
      <div className="Sala-About-Counters">
        <div className='Sala-Counters-placer'>
          <div data-aos="fade-up">
              <h2><CountUp end={55} duration={3} /></h2>
              <p>Acres</p>
          </div>
          <div data-aos="fade-up" data-aos-delay="100">
              <h2><CountUp end={100} duration={3} />+</h2>
              <p>Plots sold</p>
          </div>
          <div data-aos="fade-up" data-aos-delay="200">
              <h2><CountUp end={40} duration={3} /></h2>
              <p>Commercial Villas</p>
          </div>
        </div>
        <div className='sala-invest-text-placer'>
          <div data-aos="fade-left" data-aos-delay="300">
              <h2 className='About-counter-sider-h2'>At Sala, you don’t just invest</h2>
              <p className='About-counter-sider-p'>you inherit a legacy and grow with it.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
